
import React from 'react';
import TitleWithIcon from '../../components/common/TitleWithIcon';
import SectionBlueAndCartel from '../../components/section/SectionBlueAndCartel';
import SectionSignUp from '../../components/section/SectionSignUp';
import { SectionStore } from '../../components/section/SectionStore';
import { TEXT_KEYS } from '../../constants/textKeys';
import IMAGES_PATH from '../../Images';
import { t } from '../../translation/translation';
import './style.css'

const CARTEL_ITEMS = [
    {
        icon: IMAGES_PATH.ICON_USERS,
        title: <h4>{t(TEXT_KEYS.MISSION_CARTEL_TITLE_1_1)} <h4 className='text-blue'>{t(TEXT_KEYS.MISSION_CARTEL_TITLE_1_2)}</h4> {t(TEXT_KEYS.MISSION_CARTEL_TITLE_1_3)}</h4>,
        description: t(TEXT_KEYS.MISSION_CARTEL_DESCRIPTION_1),
    },
    {
        icon: IMAGES_PATH.ICON_WALLET,
        title: <h4>{t(TEXT_KEYS.MISSION_CARTEL_TITLE_2_1)} <h4 className='text-blue'>{t(TEXT_KEYS.MISSION_CARTEL_TITLE_2_2)}</h4> {t(TEXT_KEYS.MISSION_CARTEL_TITLE_2_3)} <h4 className='text-blue'>{t(TEXT_KEYS.MISSION_CARTEL_TITLE_2_4)}</h4></h4>,
        description: t(TEXT_KEYS.MISSION_CARTEL_DESCRIPTION_2),
    },
    {
        icon: IMAGES_PATH.ICON_TRENDING,
        title: <h4>{t(TEXT_KEYS.MISSION_CARTEL_TITLE_3_1)} <h4 className='text-blue'>{t(TEXT_KEYS.MISSION_CARTEL_TITLE_3_2)}</h4> {t(TEXT_KEYS.MISSION_CARTEL_TITLE_3_3)}</h4>,
        description: t(TEXT_KEYS.MISSION_CARTEL_DESCRIPTION_3),
    },
];

export const Mission = () => {

    const firstTitlePart = <h2>{t(TEXT_KEYS.MISSION_MAIN_TITLE_1)} <h2 className='text-blue'>{t(TEXT_KEYS.MISSION_MAIN_TITLE_2)}</h2></h2>
    const thirdTitlePart = <h2>{t(TEXT_KEYS.MISSION_MAIN_TITLE_3)}</h2>

    return (
        <div className='page-container'>
            <TitleWithIcon
                firstTitlePart={firstTitlePart}
                thirdTitlePart={thirdTitlePart}
                isIconContainer={false}
            />
            <SectionBlueAndCartel
                cartelItems={CARTEL_ITEMS}
                title={t(TEXT_KEYS.MISSION_CARTEL_TITLE)}
                underTitle={t(TEXT_KEYS.MISSION_CARTEL_SUBTITLE)}
            />
            <SectionStore />
            <SectionSignUp />
        </div>
    );
}